// extracted by mini-css-extract-plugin
module.exports = {"picker":"FontPicker_picker__0VL2R"};